import { organisationConstants } from '../../_constants/organisation.constants';

const initialState = { makeAdminLoading : true, makeAdminMessage: '', makeAdminError: false};

export function makeOrganisationAdmins(state = initialState, action) {
    switch (action.type) {
      case organisationConstants.REQUEST_PRIMARY_ADMIN_ORG:
        return {
            makeAdminLoading: true,
            makeAdminMessage: '',
            makeAdminError: false
        };
      case organisationConstants.RESPONSE_PRIMARY_ADMIN_ORG:
        return {
            makeAdminLoading: false,
            makeAdminMessage: action.adminListMake,
            makeAdminError: false
        };
      case organisationConstants.ERROR_PRIMARY_ADMIN_ORG:
        return { 
            makeAdminLoading: false,
            makeAdminMessage: '',
            makeAdminError: true
        };
      default:
        return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/organisation/makeOrgAdmin.reducer.js